import { IMaintenanceEventFilters } from '@/pages/Calendar/calendar.types'
import myOrganizationApi from '@/pages/MyOrganization/myOrganization.api'
import userAtom from '@/pages/User/user.atom'
import { IUser } from '@/pages/Users/users.types'
import alertService from '@/services/alerts/alert.service'
import useHttpLoader from '@/shared/hooks/useHttpLoader'
import { formatDate } from '@/utils/time.utils'
import { useRecoilValue } from 'recoil'

const useReportTableDownloadCtrl = (dates: IMaintenanceEventFilters, userId?: IUser['id']) => {
  const { wait, loading } = useHttpLoader()
  const userState = useRecoilValue(userAtom)
  const noDataMessage = 'Нет данных о пользователях, выполнивших ТО'

  const downloadMaintenanceReportXlsx = async (interval?: IMaintenanceEventFilters) => {
    const effectiveInterval = interval || dates
    if (!userState || !userState.organizationId || !effectiveInterval) return false

    return wait(
      myOrganizationApi.getXlsxMaintenanceReport(userState.organizationId, {
        date_gte: effectiveInterval.date_gte.toISOString(),
        date_lte: effectiveInterval.date_lte.toISOString(),
        userId,
      }),
      (resp) => {
        if (resp.status === 'success') {
          const url = URL.createObjectURL(resp.body)
          const a = document.createElement('a')
          a.href = url
          a.download = `Отчет о проведенном ТО за ${formatDate(effectiveInterval.date_gte, 'dd.MM.yyyy')} — ${formatDate(effectiveInterval.date_lte, 'dd.MM.yyyy')}.xlsx`
          a.style.display = 'none'
          a.target = '_self'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          URL.revokeObjectURL(url)
          return true
        }

        if (resp.message?.includes(noDataMessage)) {
          alertService.requestAlert({
            type: 'error',
            title: 'Отчет не сформирован',
            description: resp.message,
          })
        }

        return false
      }
    )
  }

  return {
    loading,
    downloadMaintenanceReportXlsx,
  }
}

export default useReportTableDownloadCtrl
